module.exports = __webpack_public_path__ + "mea.b029bf142b4ca2a18d78068bf4d2ad3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/mea.svg
// module id = 326
// module chunks = 0